<div class="unsicht bar" >
    <ng-content></ng-content>
</div>